import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { CardBody } from "reactstrap";
import { DocumentLayoutJSON } from "../Json/OrderDetailsLayoutJSON";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { DocumentsFieldsJSON } from "../Json/OrderDetailsFieldsJSON";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  DownloadIcon,
  EditListIcon,
  EditPrintIcon,
} from "../../../../assets/images/svg/svg";
import "./document.scss";
import {
  setCertificateField,
  setInvoiceField,
  setIsCertificateFileChanged,
  setIsInvoiceFileChanged,
} from "../../../../slices/orders/orderSlice";
import {
  commonDocumentUpload,
  downloadFileFromURL,
  getAllOrderDocument,
  uploadDocuments,
} from "../OrderService";
import { showToast } from "../../../../common/Toaster/Toaster";
import { downloadDocument } from "../../../../Utils/CommonService";

const Documents = ({ onFinish, onPrevious }) => {
  const dispatch = useDispatch();
  const formState = useSelector((state) => state.common.formRendererState);
  const params = useParams();
  const editMode = !!params.id;
  const invoiceFile = useSelector(
    (state) => state.order.selectedOrders.invoiceFile
  );
  const certificateFile = useSelector(
    (state) => state.order.selectedOrders.certificateFile
  );

  const entityid = useSelector(
    (state) => state.order.selectedOrders.detailsData.entityid
  );

  const files = useSelector(
    (state) => state.order.selectedOrders.detailsData.files
  );
  const isInvoiceFileChanged = useSelector(
    (state) => state.order.selectedOrders.isInvoiceFileChanged
  );
  const isCertificateFileChanged = useSelector(
    (state) => state.order.selectedOrders.isCertificateFileChanged
  );

  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );

  const documents = useSelector(
    (state) => state.order.selectedOrders.getAllOrderDocument
  );


  const [editInvoice, setEditInvoice] = useState(false);
  const [editCertificate, setEditCertificate] = useState(false);
  const [backupInvoiceFile, setBackupInvoiceFile] = useState(null);
  const [backupCertificateFile, setBackupCertificateFile] = useState(null);

  useEffect(() => {
    getAllOrderDocument(detailsData.entityid);
  }, [detailsData.entityid]);

  const handleFinishClick = (e) => {
    e.preventDefault();
    onFinish();
  };

  const handlePreviousClick = (e) => {
    e.preventDefault();
    onPrevious();
  };

  const handleInvoiceFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(setInvoiceField(file));
      dispatch(setIsInvoiceFileChanged(true));
    }
  };

  const handleCertificateFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(setCertificateField(file));
      dispatch(setIsCertificateFileChanged(true));
    }
  };

  const toggleEditInvoice = () => {
    if (!editInvoice) {
      setBackupInvoiceFile(invoiceFile);
    }
    setEditInvoice(!editInvoice);
  };

  const toggleEditCertificate = () => {
    if (!editCertificate) {
      setBackupCertificateFile(certificateFile);
    }
    setEditCertificate(!editCertificate);
  };

  const cancelInvoiceEdit = () => {
    dispatch(setInvoiceField(backupInvoiceFile));
    dispatch(setIsInvoiceFileChanged(false));
    setEditInvoice(false);
  };

  const cancelCertificateEdit = () => {
    dispatch(setCertificateField(backupCertificateFile));
    dispatch(setIsCertificateFileChanged(false));
    setEditCertificate(false);
  };

  const uploadOrderDocuments = () => {
    if (!invoiceFile && !certificateFile) {
      showToast("Select at least one file", "error");
      return;
    }

    uploadDocuments(entityid, "ODR", entityid, invoiceFile, certificateFile)
      .then(() => {
        setEditInvoice(false);
        setEditCertificate(false);
        dispatch(setIsInvoiceFileChanged(false));
        dispatch(setIsCertificateFileChanged(false));
      })
      .catch((error) => {
        showToast("Failed to Upload document", error);
      });
  };

  return (
    <CardBody>
      <div className="document-row">
        {documents && documents.length > 0 ? (
          <Row>
            {documents.map((document, index) => (
              <Col xs="12" md="4" key={index}>
                <Card className="file-wrapper">
                  <div className="file-content-wrapper">
                    <div>{document.name || "Document"}</div>
                    <div className="file-content">
                      <div className="filename">{document.filename}</div>
                      <div
                        className="info-icon-container"
                        onClick={() =>
                          downloadDocument(document.entityid, document.filename)
                        }
                      >
                        Download <DownloadIcon />
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div>
            <div className="no-document-found">No document found</div>
          </div>
        )}
      </div>
    </CardBody>
    // <div>
    //   <Form>
    //     <CardBody>
    //       {/* {DocumentLayoutJSON.map((element) => (
    //         <div key={element.elementid}>
    //           {element.child.map((child) =>
    //             renderElement(child, DocumentsFieldsJSON, formState)
    //           )}
    //           <DownloadIcon />
    //         </div>
    //       ))} */}

    //       <Form.Group controlId="formFileInvoice" className="mb-3">
    //         <Form.Label>Invoice</Form.Label>

    //         <div className="d-flex align-items-center">
    //           {editInvoice || !files?.invoice?.filename ? (
    //             <Form.Control
    //               type="file"
    //               className="me-2"
    //               onChange={handleInvoiceFileChange}
    //               accept=".pdf,.png"
    //             />
    //           ) : (
    //             <Form.Label className="flex-grow-1">
    //               {invoiceFile?.name || files?.invoice?.filename}
    //             </Form.Label>
    //           )}
    //           {invoiceFile && !isInvoiceFileChanged && !editInvoice && (
    //             <>
    //               <div className="icons">
    //                 <Button
    //                   variant="outline-secondary"
    //                   onClick={() =>
    //                     downloadDocumentFile(
    //                       files?.invoice?.entityid,
    //                       files?.invoice?.filename
    //                     )
    //                   }
    //                 >
    //                   <DownloadIcon />
    //                 </Button>
    //               </div>
    //               <div>
    //                 <Button
    //                   variant="outline-secondary"
    //                   onClick={toggleEditInvoice}
    //                 >
    //                   <EditListIcon />
    //                 </Button>
    //               </div>
    //             </>
    //           )}
    //           {editInvoice && (
    //             <Button variant="danger" onClick={cancelInvoiceEdit}>
    //               Cancel
    //             </Button>
    //           )}
    //         </div>
    //       </Form.Group>

    //       <Form.Group controlId="formFileCertificate" className="mb-3">
    //         <Form.Label>Certificate</Form.Label>

    //         <div className="d-flex align-items-center">
    //           {editCertificate || !files?.certificate?.filename ? (
    //             <Form.Control
    //               type="file"
    //               className="me-2"
    //               onChange={handleCertificateFileChange}
    //               accept=".pdf,.png"
    //             />
    //           ) : (
    //             <Form.Label className="flex-grow-1">
    //               {certificateFile?.name || files?.certificate?.filename}
    //             </Form.Label>
    //           )}
    //           {certificateFile &&
    //             !isCertificateFileChanged &&
    //             !editCertificate && (
    //               <>
    //                 <div className="icons">
    //                   <Button
    //                     variant="outline-secondary"
    //                     onClick={() =>
    //                       downloadDocumentFile(
    //                         files?.certificate?.entityid,
    //                         files?.certificate?.filename
    //                       )
    //                     }
    //                   >
    //                     <DownloadIcon />
    //                   </Button>
    //                 </div>

    //                 <div>
    //                   <Button
    //                     variant="outline-secondary"
    //                     onClick={toggleEditCertificate}
    //                   >
    //                     <EditListIcon />
    //                   </Button>
    //                 </div>
    //               </>
    //             )}
    //           {editCertificate && (
    //             <Button variant="danger" onClick={cancelCertificateEdit}>
    //               Cancel
    //             </Button>
    //           )}
    //         </div>
    //       </Form.Group>

    //       <div className="d-flex justify-content-between mt-3">
    //         {editInvoice ||
    //         editCertificate ||
    //         !invoiceFile ||
    //         !certificateFile ? (
    //           <Button
    //             type="button"
    //             className="btn btn-secondary"
    //             onClick={uploadOrderDocuments}
    //             disabled={!isInvoiceFileChanged && !isCertificateFileChanged}
    //           >
    //             Upload
    //           </Button>
    //         ) : (
    //           <Button
    //             type="button"
    //             className="btn btn-secondary"
    //             onClick={uploadOrderDocuments}
    //           >
    //             Upload
    //           </Button>
    //         )}
    //       </div>
    //     </CardBody>
    //     {!editMode && (
    //       <div className="d-flex justify-content-between mt-3">
    //         <Button
    //           type="button"
    //           className="btn btn-secondary"
    //           onClick={handlePreviousClick}
    //         >
    //           Previous
    //         </Button>
    //         <Button
    //           type="submit"
    //           className="btn btn-primary"
    //           onClick={handleFinishClick}
    //         >
    //           Finish
    //         </Button>
    //       </div>
    //     )}
    //   </Form>
    // </div>
  );
};

export default Documents;
